import { useEffect, useState } from "react";
import { ClockCounterClockwise, CaretDown } from "@phosphor-icons/react";
import * as API from "../lib/api";

const LABELS = {
  created: "Added",
  updated: "Changed",
  cancelled: "Cancelled",
  create_requested: "Asked to add (awaiting YES)",
  update_requested: "Asked to change (awaiting YES)",
  cancel_requested: "Asked to cancel (awaiting YES)",
  create_declined: "Declined",
  update_declined: "Declined",
  cancel_declined: "Declined",
  create_expired: "Expired",
  update_expired: "Expired",
  cancel_expired: "Expired",
  update_conflict: "Blocked — item changed",
  cancel_conflict: "Blocked — item changed",
  create_duplicate_skipped: "Duplicate skipped",
  update_denied: "Denied — not theirs",
  cancel_denied: "Denied — not theirs",
};

const TONE = {
  created: "text-emerald-300",
  updated: "text-cyan-300",
  cancelled: "text-rose-300",
};

function fmt(iso) {
  try {
    return new Date(iso).toLocaleString([], { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
  } catch {
    return iso;
  }
}

export const ScheduleActivityLog = () => {
  const [rows, setRows] = useState([]);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    API.listScheduleActivity(50).then(setRows).catch(() => setRows([]));
  }, []);

  if (!rows.length) return null;
  const shown = expanded ? rows : rows.slice(0, 5);

  return (
    <div className="mt-8" data-testid="schedule-activity-section">
      <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.18em] text-white/40 font-medium mb-3">
        <ClockCounterClockwise size={12} weight="bold" />
        Changes by contacts
      </div>
      <ul className="space-y-1.5">
        {shown.map((a) => (
          <li
            key={a.id}
            className="rounded-lg bg-white/[0.02] border border-white/5 px-3 py-2 text-sm"
            data-testid={`schedule-activity-row-${a.id}`}
          >
            <div className="flex items-baseline justify-between gap-3">
              <span className="text-white/85">
                <span className="font-medium">{a.actor_name}</span>{" "}
                <span className={TONE[a.action] || "text-white/50"}>
                  {LABELS[a.action] || a.action}
                </span>
                {a.title ? <span className="text-white/70"> · {a.title}</span> : null}
              </span>
              <span className="text-[11px] text-white/35 shrink-0">{fmt(a.at)}</span>
            </div>
            {a.summary && a.summary !== a.title && (
              <div className="text-xs text-white/45 mt-0.5">{a.summary}</div>
            )}
          </li>
        ))}
      </ul>
      {rows.length > 5 && (
        <button
          onClick={() => setExpanded((v) => !v)}
          className="mt-2 inline-flex items-center gap-1 text-xs text-cyan-300/80 hover:text-cyan-200 transition-colors"
          data-testid="schedule-activity-toggle"
        >
          <CaretDown size={12} className={expanded ? "rotate-180 transition-transform" : "transition-transform"} />
          {expanded ? "Show less" : `Show all ${rows.length}`}
        </button>
      )}
    </div>
  );
};
